// Flow entrega el monto del plan como texto ("150000"); se deja solo el número.
export function parsearMontoCLP(valor) {
  if (valor === null || valor === undefined) return null;
  const normalizado = String(valor).replace(/[^\d]/g, '');
  if (!normalizado) return null;
  const n = parseInt(normalizado, 10);
  return Number.isFinite(n) ? n : null;
}

export function formatoCLP(monto) {
  return `$${Number(monto).toLocaleString('es-CL')}`;
}
